module.exports = __webpack_public_path__ + "396354318415f629406abe379e5000ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover_chapter_3.jpg
// module id = 269
// module chunks = 0